import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export default function Soporte() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <MDTypography variant="h4" align="center">
          Centro de Ayuda / Soporte (placeholder)
        </MDTypography>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
